import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Link, Icon } from "components/common";
import { Alert, Button } from "components/bootstrap";
import LicensesRoutes from "license/Routes";
const LicenseExpirationWarningNotification = ({ expiresIn, enableReminderButton = true, onReminderClick }) => {
  const { t } = useTranslation("enterprise_license");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(
    Alert,
    {
      bsStyle: "warning",
      className: "has-bm",
      title: t("license.notifications.expiration_warning_title", { productName })
    },
    /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "license.notifications.expiration_warning_body",
        values: { productName, expiresIn },
        components: { strong: /* @__PURE__ */ React.createElement("strong", null), licensesLink: /* @__PURE__ */ React.createElement(Link, { to: LicensesRoutes.LIST }) }
      }
    ), enableReminderButton && /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", className: "pull-right", onClick: onReminderClick }, /* @__PURE__ */ React.createElement(Icon, { name: "close" }), " ", t("license.notifications.remind_later")))
  );
};
export default LicenseExpirationWarningNotification;
